import {
  CLEAR_ERROR,
  CLEAR_MESSAGE,
  GET_BANKS_SUCCESS,
  GET_BANKS,
  GET_BANK_REFERENCES_SUCCESS,
  GET_BANK_REFERENCES,
  GET_CURRENCY_TYPES_SUCCESS,
  GET_CURRENCY_TYPES,
  GET_TAX_WITHHOLDINGS_TYPES_SUCCESS,
  GET_TAX_WITHHOLDINGS_TYPES,
  HIDE_LOADER,
  INIT_ACTION_BAR,
  SET_ACTION_BAR_SHOW_REMOVE,
  SET_CURRENT_FEATURE,
  SHOW_ERROR,
  SHOW_LOADER,
  SHOW_MESSAGE,
  TRIGGER_UPDATE_NOTIFICATION,
  HIDE_UPDATE_NOTIFICATION,
  CHECK_FOR_UPDATES,
  SET_MAINTENANCE_INFO,
  CLEAR_MAINTENANCE_INFO,
  CHECK_APP_STATUS,
  CHECK_APP_STATUS_SUCCESS,
  CHECK_APP_STATUS_ERROR,
  FINISH_MAINTENANCE,
  FINISH_MAINTENANCE_SUCCESS,
  FINISH_MAINTENANCE_ERROR,
} from '../constants/ActionsTypes'

export const showLoader = () => {
  return {
    type: SHOW_LOADER,
  }
}

export const hideLoader = () => {
  return {
    type: HIDE_LOADER,
  }
}

export const showError = (error) => {
  return {
    type: SHOW_ERROR,
    payload: error,
  }
}

export const clearError = () => {
  return {
    type: CLEAR_ERROR,
  }
}

export const showMessage = (message) => {
  return {
    type: SHOW_MESSAGE,
    payload: message,
  }
}

export const clearMessage = () => {
  return {
    type: CLEAR_MESSAGE,
  }
}

export const setActionBarShowRemove = (state) => {
  return {
    type: SET_ACTION_BAR_SHOW_REMOVE,
    payload: state,
  }
}

export const initActionBarShowRemove = () => {
  return {
    type: INIT_ACTION_BAR,
  }
}

export const setCurrentFeature = (feature) => {
  return {
    type: SET_CURRENT_FEATURE,
    payload: feature,
  }
}

export const getCurrencyTypes = () => {
  return {
    type: GET_CURRENCY_TYPES,
  }
}

export const getCurrencyTypesSuccess = (data) => {
  return {
    type: GET_CURRENCY_TYPES_SUCCESS,
    payload: data,
  }
}

export const getBanks = () => {
  return {
    type: GET_BANKS,
  }
}

export const getBanksSuccess = (data) => {
  return {
    type: GET_BANKS_SUCCESS,
    payload: data,
  }
}

export const getBankReferences = () => {
  return {
    type: GET_BANK_REFERENCES,
  }
}

export const getBankReferencesSuccess = (data) => {
  return {
    type: GET_BANK_REFERENCES_SUCCESS,
    payload: data,
  }
}

export const getTaxWithholdingsTypes = () => {
  return {
    type: GET_TAX_WITHHOLDINGS_TYPES,
  }
}

export const getTaxWithholdingsTypesSuccess = (data) => {
  return {
    type: GET_TAX_WITHHOLDINGS_TYPES_SUCCESS,
    payload: data,
  }
}

export const triggerUpdateNotification = (latestVersion) => ({
  type: TRIGGER_UPDATE_NOTIFICATION,
  payload: latestVersion,
})

export const hideUpdateNotification = () => ({
  type: HIDE_UPDATE_NOTIFICATION,
})

export const checkForUpdates = () => ({
  type: CHECK_FOR_UPDATES,
})

export const setMaintenanceInfo = (info) => ({
  type: SET_MAINTENANCE_INFO,
  payload: info,
})

export const clearMaintenanceInfo = () => ({
  type: CLEAR_MAINTENANCE_INFO,
})

export const checkAppStatus = () => ({
  type: CHECK_APP_STATUS,
})

export const checkAppStatusSuccess = (data) => ({
  type: CHECK_APP_STATUS_SUCCESS,
  payload: data,
})

export const checkAppStatusError = (error) => ({
  type: CHECK_APP_STATUS_ERROR,
  payload: error,
})

export const finishMaintenance = () => ({
  type: FINISH_MAINTENANCE,
})

export const finishMaintenanceSuccess = () => ({
  type: FINISH_MAINTENANCE_SUCCESS,
})

export const finishMaintenanceError = (error) => ({
  type: FINISH_MAINTENANCE_ERROR,
  payload: error,
})
